import {
  GetTeamSsoAppClientDataRequest,
  GetTeamSsoAppClientDataResponse,
} from '@cbinsights/authservice/authservice';
import { request } from 'client/modules/common/utils/request';

export const getTeamSsoAppClientData = (
  req: Partial<GetTeamSsoAppClientDataRequest>
): Promise<GetTeamSsoAppClientDataResponse> =>
  request({
    url: '/service/authservice/GetTeamSsoAppClientData',
    body: req,
  }).then((r) => r.body);
